import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { TimeStamp, FileTypes, ViewDetail } from 'components/layouts';
import { media } from 'components/styled/utils';
import { strings } from 'config';

class DataBlock extends Component {
  goToPage = pageLink => {
    this.props.history.push(pageLink);
    window.location.reload();
  };

  render() {
    const { data } = this.props;

    return (
      <DataCard>
        <div className="card-block">
          <div className="card-block__col">
            <Title onClick={() => this.goToPage(`/detail/${data.id}`)}>
              {data.document_title} {data.published_year && <span>({data.published_year})</span>}
            </Title>

            <div className="source-time">
              <TimeStamp date={data.updated_at} />
              <ViewDetail pageLink={`/detail/${data.id}`} title={strings.dataBlock.viewDetails} />
            </div>
          </div>
          <div className="card-block__col">
            <FileTypes documents={data.documents} />
          </div>
        </div>
      </DataCard>
    );
  }
}

export default withRouter(DataBlock);

const DataCard = styled.div`
  padding: 24px;
  border: 1px solid #ebebeb;
  transition: all 0.2s ease-in;
  margin-bottom: 20px;
  &:hover {
    box-shadow: 0 4px 20px 0 rgba(168, 182, 191, 0.6);

    h4 {
      color: ${props => props.theme.teals.tilicho};
    }
  }

  .card-block {
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 992px) {
      flex-direction: row;
    }

    &__col {
      &:first-child {
        flex: 1;
      }
      &:last-child {
        display: flex;
        flex-direction: column;
        margin-top: 12px;
        ${media.xs`
          flex-direction: row;
          justify-content: space-between;
        `};

        @media screen and (min-width: 992px) {
          flex-direction: column;
          align-items: flex-end;
          width: 28%;
          margin-top: 0;
        }

        .fileTypes {
          margin-bottom: 10px;
        }
      }
    }

    .source-time {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      .sources {
        // margin-bottom: 12px;
      }

      .view-detail,
      .timestamp {
        margin-top: 14px;
      }

      @media screen and (min-width: 480px) {
        .view-detail {
          margin-left: 24px;
        }
      }

      .timestamp {
        white-space: nowrap;
      }

      @media screen and (min-width: 480px) {
        flex-direction: row;
        align-items: center;
      }
    }
  }
`;

const Title = styled.h4`
  color: ${props => props.theme.primary.raatri};
  font-size: 16px;
  margin-bottom: 10px;
  line-height: 1.3;
  cursor: pointer;
  transition: color 0.1s ease-in;
  &:hover {
    color: ${props => props.theme.primary.ujyaalo};
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/dataList/dataBlock.js